module.exports = __webpack_public_path__ + "img/36.f10baf30.png";